import { AuthMethods, TotpRegisterAuth } from '@models/auth.model';

export interface SessionState {
  token             : string | null,
  refreshToken      : string | null,
  authMethods       : AuthMethods | null,
  totpRegisterAuth  : TotpRegisterAuth | null,
  verifyMethodError : string | null,
};

export const initialState: SessionState = {
  token: null,
  refreshToken: null,
  authMethods: null,
  totpRegisterAuth: null,
  verifyMethodError: null,
};